import { API } from 'aws-amplify'

import { RISK_ASSESSMENT_API_NAME } from '../../../utils/env'

const SiteService = {
  async list() {
    const response = await API.get(RISK_ASSESSMENT_API_NAME, '/sites')

    return response.sites
  },
}

export { SiteService }
